import { Button } from "@/components/ui/button";
import { Headphones } from "lucide-react";

export function FinalCTA() {
  return (
    <section className="py-24 bg-hero-gradient">
      <div className="container mx-auto px-4 text-center max-w-2xl">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-primary-foreground mb-4">
          Comienza tu senda hoy
        </h2>
        <p className="text-primary-foreground/70 mb-8 leading-relaxed">
          Únete a miles de creyentes que fortalecen su fe cada día con audiolibros y libros cristianos.
        </p>
        <Button variant="hero" size="lg" className="text-base px-10">
          <Headphones className="h-5 w-5 mr-2" />
          Comenzar gratis
        </Button>
      </div>
    </section>
  );
}
